import { IBoardMenu } from "app/types";
import { ItemWidths } from "./types";

export const calculateBoardVisibility = (
  options: IBoardMenu[],
  containerWidth: number | null,
  widths: ItemWidths
): { visibleBoards: IBoardMenu[]; hiddenBoards: IBoardMenu[] } => {
  if (!containerWidth || !options?.length) {
    return { visibleBoards: options || [], hiddenBoards: [] };
  }

  const availableWidth =
    containerWidth - widths.home - widths.addBoard - widths.padding;
  let usedWidth = 0;
  let visibleCount = 0;

  for (let i = 0; i < options.length; i++) {
    const needsMoreButton = i < options.length - 1;
    const totalNeededWidth =
      usedWidth + widths.board + (needsMoreButton ? widths.more : 0);
    if (totalNeededWidth <= availableWidth) {
      usedWidth += widths.board;
      visibleCount++;
    } else {
      break;
    }
  }

  if (
    visibleCount === 0 &&
    options.length > 0 &&
    availableWidth > widths.board
  ) {
    visibleCount = 1;
  }

  return {
    visibleBoards: options.slice(0, visibleCount),
    hiddenBoards: options.slice(visibleCount),
  };
};
